<template>
  <v-tile
    ref="tile"
    class="c-tile--hero-multiple"
    :product="product"
  >
    <div
      class="c-tile__wrapper"
      @mouseenter="playTrailer"
      @mouseleave="stopTrailer"
    >
      <v-play-product
        v-if="showPlayProduct"
        class="c-tile__play-product"
        autoplay-redirect
        mouse-entered
        outline
        show-label
        :product="product"
      ></v-play-product>
      <v-trailer
        ref="trailer"
        :delay="0"
        :product="product"
        :mode="TrailerMode.HERO"
        class="c-tile__trailer"
      ></v-trailer>
      <v-progress
        v-if="$section.tileProgress"
        :product="product"
        class="c-tile__progress"
      ></v-progress>
      <v-badge
        :product="product"
        class="c-tile__badge"
        :counting="isPlaying"
      ></v-badge>
    </div>
    <div class="c-tile__details">
      <h3
        v-dompurify-html="title"
        class="c-tile__title"
      ></h3>
      <div class="c-tile__subtitle">
        <span
          v-if="isClip"
          class="o-icon o-icon--time"
        ></span>
        {{ subtitle }}
      </div>
    </div>
  </v-tile>
</template>
<script>
  import { VBadge, VPlayProduct, VProgress, VTile, VTrailer } from '@/index/shared/components';
  import { getFormatedMonthDateWithTime, meta } from '@/index/shared/filters';
  import { productMixin } from '@/index/shared/mixins';
  import { ProductType, TrailerMode } from '@/shared/enums';
  import { subtitleKeysMixin } from '../mixins/index';

  export default {
    components: {
      VBadge,
      VPlayProduct,
      VProgress,
      VTile,
      VTrailer,
    },
    enums: {
      TrailerMode,
    },
    filters: {
      getFormatedMonthDateWithTime,
      meta,
    },
    mixins: [
      productMixin,
      subtitleKeysMixin,
    ],
    inject: ['$section'],
    props: {
      imageType: String,
      product: Object,
      showPlayProduct: Boolean,
    },
    data() {
      return {
        sinceTime: '',
        sinceInterval: 0,
        isPlaying: false,
      };
    },
    computed: {
      isProgramme() {
        return this.product.type === ProductType.PROGRAMME;
      },
      isClip() {
        return this.product.type === ProductType.CLIP;
      },
      title() {
        return meta(this.product, 'richTitle');
      },
      subtitle() {
        if (this.isProgramme) {
          return this.programRange;
        }

        return meta(this.product, this.subtitleKeys);
      },
      programRange() {
        return getFormatedMonthDateWithTime(this.product.since, this.product.till);
      },
    },
    mounted() {
      if (this.isClip) {
        this.getSinceTime();
        this.sinceInterval = setInterval(this.getSinceTime, 1000 * 60);
      }
    },
    beforeDestroy() {
      clearInterval(this.sinceInterval);
    },
    methods: {
      playTrailer() {
        this.$nextTick(() => this.$refs.trailer.play());
        this.isPlaying = true;
      },
      stopTrailer() {
        this.$refs.trailer.stop();
        this.isPlaying = false;
      },
      getSinceTime() {
        this.sinceTime = meta(this.product, 'sinceTime');
      },
    },
  };
</script>
